export const authT = {
  en: {
    bannerLine1: 'Turn ideas',
    bannerLine2: 'into interactive courses',
    or: 'or',

    title: 'Sign in to your account',
    google: 'Continue with Google',
    emailLabel: 'Email',
    emailPlaceholder: 'Enter your email',
    submit: 'Get sign-in link',
    submitting: 'Sending…',
    invalidEmail: 'Enter a valid email',
    errUserNotFoundBefore: "You don't have an Open Academy account yet. Create one at ",
    errUserNotFoundAfter: ', then sign in to OA Studio with the same email.',

    termsBefore: 'By continuing, you agree to the',
    termsLink: 'Terms of Use',
    termsAnd: 'and',
    privacyLink: 'Privacy Policy',

    sentBack: 'Back',
    sentTitle: 'Check your email',
    sentBody1: 'A sign-in link has been sent to',
    sentBody2: 'Click it to sign in.',
    sentChangeEmail: 'Use a different email',
    sentNoLink: "Didn't get the link? Check your Spam folder.",
    sentSupportPrefix: 'Still no luck —',
    sentSupportLink: 'contact support',

    errEmailSend: 'Couldn’t send the sign-in link',
    errGoogleUrl: 'Couldn’t start Google sign-in',
    errGoogleUrlInvalid: 'The Google sign-in link is invalid',
    errGoogleGeneric: 'Couldn’t sign in with Google',
  },
  ru: {
    bannerLine1: 'Превращай идеи',
    bannerLine2: 'в интерактивные курсы',
    or: 'или',

    title: 'Войдите в аккаунт',
    google: 'Войти через Google',
    emailLabel: 'Email',
    emailPlaceholder: 'Введите ваш email',
    submit: 'Получить ссылку для входа',
    submitting: 'Отправка...',
    invalidEmail: 'Введите корректный email',
    errUserNotFoundBefore: 'У вас пока нет аккаунта Open Academy. Зарегистрируйтесь на ',
    errUserNotFoundAfter: ' — затем войдите в OA Studio с той же почтой.',

    termsBefore: 'Продолжая, вы соглашаетесь с',
    termsLink: 'Условиями использования',
    termsAnd: 'и',
    privacyLink: 'Политикой конфиденциальности',

    sentBack: 'Назад',
    sentTitle: 'Проверьте почту',
    sentBody1: 'Ссылка для входа отправлена на',
    sentBody2: 'Перейдите по ней, чтобы войти.',
    sentChangeEmail: 'Использовать другой email',
    sentNoLink: 'Ссылка не пришла? Проверьте папку «Спам».',
    sentSupportPrefix: 'Если не помогло —',
    sentSupportLink: 'напишите в поддержку',

    errEmailSend: 'Не удалось отправить ссылку для входа',
    errGoogleUrl: 'Не удалось получить URL для входа через Google',
    errGoogleUrlInvalid: 'Некорректный URL для входа через Google',
    errGoogleGeneric: 'Ошибка входа через Google',
  },
}
